import React, { CSSProperties } from "react";

import { Tag } from "@puzzle/ui";

// Gradient tag is not working as expected due to zIndex stacking issues
// This is a temporary fix to ensure the tag is displayed correctly by isolating it on the z-index layer
// TODO: remove this once we have a proper solution for the gradient tag
const CONTAINER_STYLES: CSSProperties = {
  isolation: "isolate",
};

export const AlphaTag = () => {
  return (
    <div style={CONTAINER_STYLES}>
      <Tag variant="gradient">Alpha</Tag>
    </div>
  );
};
